import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {BrowserRouter as Router} from "react-router-dom";
import clsx from "clsx";
import {Box} from "@material-ui/core";
import Routes from "../routes";
import AppDrawer from "./components/AppDrawer/AppDrawer";
import AppHeader from "./components/AppHeader/AppHeader";
import {useStyles} from "./styles";
import {getDepartment, getUserInfo, setDepartment,} from "../../../utilities/storage";
import {setSelectedDept} from "../../Users/UsersActions";
import DepartmentsDialog from "./components/DepartmentsDialog/DepartmentsDialog";
import {getUserDeptsRequest} from "../../Users/UsersApiActions";

const Dashboard = ({
                     history,
                     setSelectedDept,
                     getUserDepts,
                     selectedDept,
                   }) => {
  const classes = useStyles();
  const role = getUserInfo().Roles[0].name;
  const open = true;
  const [openChooseDepartmentDialog, setOpenChooseDepartmentDialog] =
    useState(false);
  const [dept, setDept] = useState(null);

  useEffect(() => {
    if (!getDepartment()) {
      getUserDepts(getUserInfo().id).then((res) => {
        if (res.teams.length > 0) {
          setOpenChooseDepartmentDialog(false);
          setSelectedDept(res.teams[0]);
          setDepartment(res.teams[0]);
        }
      });
    }
  }, [getUserDepts, setSelectedDept]);

  useEffect(() => {
    if (getDepartment()) {
      getUserDepts(getUserInfo().id).then((res) => {
        const updatedDept = res.teams.find(
          (team) => team.team_id === getDepartment().team_id
        );
        setSelectedDept(updatedDept);
        setDepartment(updatedDept);
      });
    }
  }, [getUserDepts, setSelectedDept]);

  const onDialogSubmit = () => {
    setSelectedDept(dept);
    setDepartment(dept);
    setOpenChooseDepartmentDialog(false);
  };

  return (
    <Router>
      <Box>
        <DepartmentsDialog
          dept={dept}
          setDept={setDept}
          open={openChooseDepartmentDialog}
          onSubmit={onDialogSubmit}
        />
        <AppHeader open={open} />
        <Box>
          <AppDrawer
            open={open}
            history={history}
          />
          <Box
            className={clsx(
              classes.userContent,
              open && classes.userContentShift
            )}
          >
            <Routes history={history}/>
          </Box>
        </Box>
      </Box>
    </Router>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedDept: state.ayucareUsers.selectedDept,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedDept: (data) => {
      return dispatch(setSelectedDept(data));
    },
    getUserDepts: (id) => {
      return dispatch(getUserDeptsRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
